import RangeSliderField, { RangeSliderFieldProps } from './range-slider-field';

const formatGameweekLabel = (gameweek: number) => `GW${gameweek}`;

type GameweekRangeSliderProps = Omit<
  RangeSliderFieldProps,
  'step' | 'formatLabel' | 'pillMinWidthClassName' | 'label'
> & {
  label?: string;
};

/** The site-wide gameweek range filter, with "GW" pills at either end. */
const GameweekRangeSlider = ({
  label = 'Gameweeks',
  ...props
}: GameweekRangeSliderProps) => (
  <RangeSliderField
    {...props}
    label={label}
    step={1}
    formatLabel={formatGameweekLabel}
    // Fits GW38.
    pillMinWidthClassName="!min-w-[54px]"
  />
);

export default GameweekRangeSlider;
